import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../lib/i18n";
import { IMG } from "../lib/dict";
import { SectionHead } from "./Reveal";

const Frame = ({ p, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const offset = i % 2 === 1 ? "md:mt-24" : "";
  return (
    <div ref={ref} className={offset}>
      <motion.figure initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }} className="group" data-testid={`work-item-${i}`}>
        <div className="clip-frame relative aspect-[4/5] overflow-hidden rounded-[22px] border border-emerald-500/20 bg-[#0C1210] sm:aspect-[5/6]">
          <motion.img style={{ y, scale: 1.18 }} src={IMG[p.img]} alt={p.title} loading="lazy" className="h-full w-full object-cover grayscale-[60%] transition-[filter] duration-700 group-hover:grayscale-0" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050706]/90 via-transparent to-transparent" />
          <div className="spotlight absolute inset-0 opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
          <span className="absolute left-5 top-5 rounded-full border border-emerald-400/40 bg-[#050706]/70 px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-[#00E676] backdrop-blur-md">{p.tag}</span>
        </div>
        <figcaption className="mt-5 flex items-baseline justify-between border-b border-emerald-500/15 pb-4">
          <h3 className="font-display text-xl font-extrabold uppercase tracking-tight text-white sm:text-2xl">{p.title}</h3>
          <span className="font-mono text-xs text-zinc-400">/0{i + 1}</span>
        </figcaption>
      </motion.figure>
    </div>
  );
};

export const Work = () => {
  const { t } = useLang();
  return (
    <section id="work" className="relative border-t border-emerald-500/10 bg-[#070A09] py-24 sm:py-36" data-testid="work-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <SectionHead eyebrow={t.work.eyebrow} title={t.work.title} accent={t.work.accent} testid="work-title" />
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-8 lg:gap-14">
          {t.work.items.map((p, i) => <Frame key={p.img} p={p} i={i} />)}
        </div>
      </div>
    </section>
  );
};
